import { render, staticRenderFns } from "./mnGebr.vue?vue&type=template&id=a5bd1da2"
import script from "./mnGebr.vue?vue&type=script&lang=js"
export * from "./mnGebr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports